import { CustomEventType } from '@/features/types'

export const handleOpenAppAuthModal = () => {
    const openEvent = new CustomEvent(CustomEventType.AuthModal, {
        bubbles: true,
    })

    document.dispatchEvent(openEvent)
}
